import { RecentUsersResp } from 'types/api/response/recent-users-resp'

import { api } from './api'

export async function getRecentUsers(keyword?: string) {
  return api.get<RecentUsersResp>('/help_center/recent_users', {
    params: { keyword },
  })
}
